module.exports = __webpack_public_path__ + "static/ITAR-f3c9851ef5a03700c22810246b87012a.png";